import { NewSms } from '../sms-service/sms-new.model';
import { Borrower } from 'app/modules/borrower/models/borrower/borrower.model';

export class AddSms {
	static readonly type = '[Sms] Add';
	constructor(public sms: NewSms) {}
}

export class GetSmsVariables {
	static readonly type = '[Sms] GetSmsVariables';
	constructor(public borrowerId: number) {}
}

export class SubscribeToBorrowerTexts {
	static readonly type = '[Sms] SubscribeToBorrowerTexts';
	constructor(public borrowerId: number) {}
}

export class GetBorrowerSmsHistory {
	static readonly type = '[Sms] GetBorrowerSmsHistory';
	constructor(public borrowerId: number) {}
}

export class GetFullBorrowerSmsHistory {
  static readonly type = '[Sms] GetFullBorrowerSmsHistory';
  constructor(public borrowerId: number) {}
}

export class ClearSmsStore {
	static readonly type = '[Sms] ClearSmsStore';
    constructor(public borrowerId: number) {}
}

export class GetUnknownSms {
	static readonly type = '[Sms] GetUnknownSms';
	constructor(public lenderUserId: number) {}
}

export class DeleteSmsFromUnknownSender {
	static readonly type = '[Sms] DeleteSmsFromUnknownSender';
	constructor(public smsId: number) {}
}

export class AddBorrowerToSms {
	static readonly type = '[Sms] AddBorrowerToSms';
	constructor(public smsId: number, public borrower: Borrower) {}
}

export class SmsAlertDismissed {
	static readonly type = '[Sms] SmsAlertDismissed';
	constructor() {}
}

export class MarkSmsRead {
  static readonly type = '[Sms] MarkSmsRead';
  constructor(
    public lenderUserId: number,
    public smsIds: Array<number>,
    public borrowerId?: number,
  ) {
  }
}

export class MarkSmsUnread {
	static readonly type = '[Sms] MarkSmsUnread';
	constructor(
		public lenderUserId: number,
		public smsIds: Array<number>,
		public borrowerId?: number,
	) {}
}
